export const CheckStringLanguage = (value) => {
    if (typeof value !== "string") return false;

    const trimmed = value.trim();
    if (trimmed.length === 0) return false;

    const firstChar = trimmed.charAt(0);
    const isArabic = /[\u0600-\u06FF]/.test(firstChar);

    return isArabic;
};

export const toArabicNumbers = (num, MainLang) => {

    if (MainLang === "en")
        return num



    return num.toString().replace(/\d/g, (digit) => "٠١٢٣٤٥٦٧٨٩"[digit]);

}